/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BasePromoBannerItemFragment} from '@amblique/contentful/app/contentful/fragments/promo-banner-item/base-promo-banner-item.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';

export const FullPromoBannerItemFragment = gql`
  ${BasePromoBannerItemFragment}
  ${LinkFragment}

  fragment FullPromoBannerItemFragment on PromoBannerItem {
    ...BasePromoBannerItemFragment

    link {
      ...LinkFragment
    }
  }
`;
